'use strict';
require('./add-to-row-at-index');
require('./mindmup-editabletable');
require('./numeric-totaliser');

const mmWidgets = require('../widgets/mm-widgets'),
	ESC = 27;
mmWidgets.fn.measuresSheetWidget = function (measuresModel, opts) {
	const options = opts || {};
	return mmWidgets.each(this, function () {
		let focused = false;

		const element = this,
			measurementsTable = element.find('[data-mm-role=measurements-table]'),
			noMeasuresDiv = element.find('[data-mm-role=no-measures]'),
			measurementTemplate = element.find('[data-mm-role=measurement-template]'),
			measurementContainer = measurementTemplate.parent(),
			ideaTemplate = element.find('[data-mm-role=idea-template]'),
			valueTemplate = ideaTemplate.find('[data-mm-role=value-template]').detach(),
			ideaContainer = ideaTemplate.parent(),
			summaryTemplate = element.find('[data-mm-role=summary-template]'),
			summaryContainer = summaryTemplate.parent(),
			getRowForNodeId = function (nodeId) {
				return element.find('[data-mm-nodeid="' + nodeId + '"]');
			},
			getColumnIndexForMeasure = function (measureName) {
				if (!measureName) {
					return -1;
				}
				return measurementContainer.children().domElements.map(domElement => {
					return mmWidgets(domElement).find('[data-mm-role=measurement-name]').text();
				}).indexOf(measureName);
			},
			appendMeasure = function (measureName, index) {
				const measurement = measurementTemplate.clone().addToRowAtIndex(measurementContainer, index),
					onClick = function () {
						measuresModel.setSelectedMeasure(measureName);
					};
				measurement.find('[data-mm-role=measurement-name]').text(measureName).click(onClick);
				measurement.find('[data-mm-role=remove-measure]').click(function () {
					measuresModel.removeMeasure(measureName);
				});
				summaryTemplate.clone().addToRowAtIndex(summaryContainer, index).text('0').click(onClick);
				measurementsTable.removeClass('hidden');
				noMeasuresDiv.addClass('hidden');
			},
			onFocused = function (nowFocused, nodeId) {
				if (nowFocused !== focused) {
					focused = nowFocused;
					measuresModel.editingMeasure(nowFocused, nodeId);
				}
			},
			appendMeasureValue = function (container, value, nodeId, measureName, index) {
				const current = container.children('[data-mm-role=value-template]').eq(index),
					valueCell = valueTemplate.clone();
				valueCell.text(value || '0')
				.on('change', function (evt) {
					if (!measuresModel.setValue(nodeId, measureName, evt.newValue)) {
						evt.preventDefault();
					}
				}).on('focus', function () {
					measuresModel.setSelectedMeasure(measureName);
					onFocused(true, nodeId);
				}).on('blur', function () {
					onFocused(false, nodeId);
				}).on('keydown', e => {
					if (e.which === ESC) {
						valueCell.blur();
						e.preventDefault();
						e.stopPropagation();
					}
				});


				if (current.length) {
					valueCell.insertBefore(current);
				} else {
					valueCell.appendTo(container);
				}
				return valueCell;
			},
			onMeasuresContext = function (context) {
				const col = context.selectedMeasure &&  getColumnIndexForMeasure(context.selectedMeasure),
					labelCol = context.labelledMeasure && getColumnIndexForMeasure(context.labelledMeasure);
				if (context.hasMeasures) {
					measurementsTable.removeClass('hidden');
					noMeasuresDiv.addClass('hidden');
					measurementContainer.children().removeClass('mm-selected').removeClass('mm-labelled');
					summaryContainer.children().removeClass('mm-selected');
					element.find('[data-mm-nodeid]').children().removeClass('mm-selected');


					if (col) {
						measurementContainer.children().eq(col).addClass('mm-selected');
						summaryContainer.children().eq(col).addClass('mm-selected');
						element.find('[data-mm-nodeid]').domElements.forEach(rowDom => {
							const colDom = rowDom && rowDom.children && Array.from(rowDom.children)[col];
							if (colDom) {
								colDom.classList.add('mm-selected');
							}
						});
					}
					if (labelCol) {
						measurementContainer.children().eq(labelCol).addClass('mm-labelled');
					}
				} else {
					measurementsTable.addClass('hidden');
					noMeasuresDiv.removeClass('hidden');
				}
			},
			onMeasureValueChanged = function (nodeId, measureChanged, newValue) {
				const row = getRowForNodeId(nodeId),
					col = getColumnIndexForMeasure(measureChanged);
				if (col >= 0) {
					row.children().eq(col).text(newValue);
					measurementsTable.trigger(mmWidgets.Event('change', {'column': col}));
				}
			},
			onMeasureAdded = function (measureName, index) {
				appendMeasure(measureName, index);
				ideaContainer.children().domElements.forEach(domElement => {
					const idea = mmWidgets(domElement);
					appendMeasureValue(idea, '0', idea.attr('data-mm-nodeid'), measureName, index);
				});
			},
			onMeasureLabelShown = function (measureName) {
				measurementContainer.children().removeClass('mm-active');
				const col = getColumnIndexForMeasure(measureName);
				if (col >= 0) {
					measurementContainer.children().eq(col).addClass('mm-active');
				}
			},
			onMeasureRemoved = function (measureName) {
				const col = getColumnIndexForMeasure(measureName);
				if (col < 0) {
					return;
				}
				measurementContainer.children().eq(col).remove();
				summaryContainer.children().eq(col).remove();
				ideaContainer.children().domElements.forEach(rowDom => {
					const colDom = rowDom && rowDom.children && Array.from(rowDom.children)[col];
					if (colDom) {
						colDom.remove();
					}

				});
			},
			buildMeasureRows = function (measures) {
				const calculateTitleText = (domElement, mv) => {
					if (!domElement) {
						return '';
					};
					const truncLength = domElement.getAttribute('data-mm-truncate');
					if (truncLength && mv.title.length > truncLength) {
						return mv.title.substring(0, truncLength) + '...';
					}
					return mv.title;
				};
				ideaContainer.children('[data-mm-role=idea-template]').remove();
				measuresModel.getMeasurementValues().forEach(function (mv) {
					const newIdea = ideaTemplate.clone().appendTo(ideaContainer).attr('data-mm-nodeid', mv.id),
						ideaTitleWidgets = newIdea.find('[data-mm-role=idea-title]');
					ideaTitleWidgets.domElements.forEach(domElement => {
						domElement.innerText = calculateTitleText(domElement, mv);
					});
					measures.forEach(measure => {
						appendMeasureValue(newIdea, mv.values[measure], mv.id, measure);
					});
				});
				element.find('[data-mm-role=measurements-table]').trigger('change');
			},
			buildMeasureTable = function () {
				measurementContainer.children('[data-mm-role=measurement-template]').remove();
				summaryContainer.children('[data-mm-role=summary-template]').remove();
				const measures = measuresModel.getMeasures();
				measures.forEach(appendMeasure);
				buildMeasureRows(measures);
			},
			onMeasureRowsChanged = function () {
				buildMeasureRows(measuresModel.getMeasures());
			};


		measurementTemplate.detach();
		summaryTemplate.detach();
		ideaTemplate.detach();
		if (!options.readOnly) {
			measurementsTable.editableTableWidget({
				editor: element.find('[data-mm-role=measures-editor]'),
				cloneProperties: mmWidgets.fn.editableTableWidget.defaultOptions.cloneProperties.concat(['outline', 'box-shadow', '-webkit-box-shadow', '-moz-box-shadow'])
			})
			.on('validate', function (evt) {
				measuresModel.editingMeasure(true);
				if (!measuresModel.validate(evt.newValue)) {
					evt.preventDefault();
				}
			});
			element.find('[data-mm-role=measures-editor]')
			.on('focus', onFocused.bind(element, true, false))
			.on('blur', onFocused.bind(element, false, false));
		} else {
			element.find('[data-mm-role=measures-editor]').remove();
		}
		measurementsTable.numericTotaliser();

		element.on('show', function () {
			buildMeasureTable();
			measuresModel.addEventListener('startFromScratch', buildMeasureTable);
			measuresModel.addEventListener('measureRowsChanged', onMeasureRowsChanged);
			measuresModel.addEventListener('measureValueChanged', onMeasureValueChanged);
			measuresModel.addEventListener('measureAdded', onMeasureAdded);
			measuresModel.addEventListener('measureRemoved', onMeasureRemoved);
			measuresModel.addEventListener('measuresContext', onMeasuresContext);
			measuresModel.setActive(true);

		});
		element.on('hide', function () {
			measuresModel.removeEventListener('startFromScratch', buildMeasureTable);
			measuresModel.removeEventListener('measureRowsChanged', onMeasureRowsChanged);
			measuresModel.removeEventListener('measureValueChanged', onMeasureValueChanged);
			measuresModel.removeEventListener('measureAdded', onMeasureAdded);
			measuresModel.removeEventListener('measureRemoved', onMeasureRemoved);
			measuresModel.removeEventListener('measuresContext', onMeasuresContext);
			measuresModel.setActive(false);
			element.parent().parent().children('[tabindex]').focus();
		});
		measuresModel.addEventListener('measureLabelShown', onMeasureLabelShown);
	});

};
